import { useState } from 'react';
import { faqList } from '@/mocks/chaoyang';

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="changjian" className="mx-auto w-full max-w-7xl scroll-mt-20 px-4 py-12 md:px-6 md:py-16">
      <div className="mx-auto max-w-3xl">
        <div className="mb-8 text-center">
          <p className="mb-2 text-sm font-medium text-primary-600">关于朝阳吃瓜，你可能想问</p>
          <h2 className="text-2xl font-bold text-foreground-950 md:text-3xl">常见问题</h2>
          <p className="mt-2 text-sm text-foreground-600">榜单怎么算、怎么投稿、来源可信吗，一次说清。</p>
        </div>

        <div className="space-y-3">
          {faqList.map((item, i) => {
            const open = openIdx === i;
            return (
              <div
                key={i}
                className="overflow-hidden rounded-xl border border-background-200 bg-background-50"
              >
                <button
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left md:px-5"
                >
                  <h3 className="flex items-center gap-3 text-sm font-semibold text-foreground-950 md:text-base">
                    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-100 text-xs text-primary-700">
                      Q
                    </span>
                    {item.q}
                  </h3>
                  <i
                    className={`shrink-0 text-xl text-foreground-500 transition-transform duration-300 ${
                      open ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </button>
                <div
                  className={`grid transition-all duration-300 ease-in-out ${
                    open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className="overflow-hidden">
                    <div className="px-4 pb-5 pl-14 md:px-5 md:pl-14">
                      <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}